import axios from 'api/axios'
import { Template } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * API call for sync status of template
 * @param id - id of template to be send to backend for sync status of template
 * @returns AdminResponse - Response object returned from the server
 */

export const syncTemplateStatus = async (id: string) => {
	try {
		const { data } = await axios.patch<Template>(
			`templates/list/${id}/status-sync`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default syncTemplateStatus
